import React from 'react';
import { Grid, Chip, Typography } from '@mui/material';
import Tile from 'components/Tile/Tile';
import { useWorkflowStyles } from './styles';
import { VOStatus, WorkflowEventType } from './constants';
import { CreditLineStatusEnum } from '@trnsact/trnsact-shared-types';

interface WorkflowNodeConditionProps {
  selectedConditions: (VOStatus | CreditLineStatusEnum)[];
  selectedEvent: WorkflowEventType;
  onClick: () => void;
  onDeleteCondition: (index: number) => void;
}

const WorkflowNodeCondition: React.FC<WorkflowNodeConditionProps> = ({
  selectedConditions,
  selectedEvent,
  onClick,
  onDeleteCondition,
}) => {
  const classes = useWorkflowStyles();

  const getConditionLabel = () => {
    switch (selectedEvent) {
      case WorkflowEventType.VENDOR_OPPORTUNITY_UPDATED:
        return 'Opportunity Stage';
      case WorkflowEventType.CREDIT_LINE_STATUS_UPDATED:
        return 'Credit Line Status';
      default:
        return 'Condition';
    }
  };

  return (
    <Grid item xs={8} className={classes.nodeContainer} onClick={onClick}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Tile className={classes.nodeTitle}>Condition</Tile>
        </Grid>
        <Grid item xs={12}>
          {selectedConditions.length > 0 ? (
            <div className={classes.conditionChipContainer}>
              <Grid container spacing={1} justifyContent="space-evenly">
                <Grid item xs={12}>
                  <Chip key={'initialCondition'} label={'IF'} color="primary" />
                </Grid>

                {selectedConditions.map((condition, index) => (
                  <React.Fragment key={index}>
                    <Grid item>
                      <Chip
                        label={
                          <div>
                            {getConditionLabel()} = <span className={classes.chosenConditionColor}>{condition}</span>
                          </div>
                        }
                        onDelete={() => onDeleteCondition(index)}
                      />
                    </Grid>
                    {selectedConditions.length > 1 && index + 1 < selectedConditions.length ? (
                      <Grid item>
                        <Chip key={`${index}_CONNECTOR_OR`} label={`OR`} variant="outlined" />
                      </Grid>
                    ) : null}
                  </React.Fragment>
                ))}
              </Grid>
            </div>
          ) : (
            <Typography variant="body2" color="textSecondary">
              Click here to set Condition
            </Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WorkflowNodeCondition;
